/*
 * @Descripttion:
 * @version: v1
 * @Author: liukx
 * @Date: 2022-05-05 20:23:32
 * @LastEditors: ???
 * @LastEditTime: 2022-05-08 16:29:24
 */
// import Cookies from 'js-cookie'

const TokenKey = '_TOKEN_';
import Vue from 'vue';
import Storage from 'vue-ls';

Vue.use(Storage, {
  namespace: 'lkx__', // key prefix
  name: 'ls', // name variable Vue.[ls] or this.[$ls],
  storage: 'local', // storage name session, local, memory
});

export function getToken() {
  // return Cookies.get(TokenKey)
  return Vue.ls.get(TokenKey);
}

export function setToken(token) {
  // return Cookies.set(TokenKey, token)
  return Vue.ls.set(TokenKey, token, 7 * 24 * 60 * 60 * 1000);
}

export function removeToken() {
  // return Cookies.remove(TokenKey)
  return Vue.ls.remove(TokenKey);
}
